<template>
  <div class="supplier-container">
    <div class="supplier-layout">
      <!-- 左侧标签栏 -->
      <div class="custom-tabs">
        <div
          class="tab-item"
          v-for="tab in tabs"
          :key="tab.name"
          :class="{ active: activeTab === tab.name }"
          @click="handleTabClick(tab.name)"
        >
          <div class="tab-icon">
            <img
              :src="activeTab === tab.name ? tab.iconed : tab.icon"
              style="width: 25px; height: 25px"
            />
          </div>
          <div class="tab-label">{{ tab.label }}</div>
        </div>
      </div>

      <!-- 右侧内容区 -->
      <div class="supplier-content dark-theme">
        <el-carousel
          :interval="5000"
          arrow="always"
          height="540px"
          indicator-position="outside"
        >
          <el-carousel-item
            v-for="(supplier, index) in suppliers[activeCategory]"
            :key="index"
          >
            <div class="supplier-display">
              <div
                class="supplier-images"
                :class="`image-count-${Math.min(supplier?.imgs.length, 4)}`"
              >
              <div
                  v-for="(img, iIndex) in supplier.imgs.slice(0, 4)"
                  :key="iIndex"
                  class="image-wrapper"
                >
                  <div>
                    <el-image
                      :src="img.img"
                      fit="contain"
                      class="supplier-image"
                      :preview-src-list="[img.img]"
                    >
                      <div slot="error" class="image-error">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <div class="image-caption">{{ img.name }}</div>
                </div>
                
              </div>
              <!-- 添加标题 -->
              <div class="supplier-title">
                {{ supplier.title }}
              </div>

            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { getSupplier2 } from "../api/api";
export default {
  data() {
    return {
      activeTab: "all",     
      activeCategory: "all",
      // suppliers: {},
    };
  },
  props: ["suppliers", "tabs"],
  methods: {
    handleTabClick(tabName) {
      this.activeTab = tabName;
      // 这里可以添加切换分类的逻辑
      this.activeCategory = this.getCategoryByTab(tabName);
    },
    getCategoryByTab(tabName) {
      // 根据tab返回对应的分类key
      const map = {
        rice: "rice",
        meat: "meat",
        vegetable: "vegetable",
        freeze: "freeze",
        drink: "drink",
        gantiao: "gantiao",
      };
      return map[tabName] || "rice";
    },
    // 供应商公示
    // async getSupplier2() {
    //   const res = await getSupplier2();
    //   this.suppliers = res.data.data;
    // },
  },
  mounted() {
    // this.getSupplier2();    
  },
};
</script>

<style scoped>
.supplier-container {
  display: flex;
  flex-direction: column;
  min-height: 380px;
  background: transparent;
  border-radius: 12px;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    Arial, sans-serif;
}

/* 新增的布局容器 */
.supplier-layout {
  display: flex;
  height: 100%;
  min-height: 600px;
}

/* 左侧标签栏样式 */
.custom-tabs {
  display: flex;
  flex-direction: column;
  width: 150px;
  padding: 20px 0;
  background: rgba(255, 255, 255, 0.05);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 5px;
  margin: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgb(198, 227, 235);
  /* color: rgb(62, 72, 96); */
  color: #999;
}

.tab-item:hover {
  background: rgba(0, 0, 0, 0.05);
}

.tab-item.active {
  background: linear-gradient(to bottom, #0f2b4d, #1a4b7a);
  color: #fff;
  font-size: 17px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border-color: transparent;
  border: 1px solid rgb(198, 227, 235);
}

.tab-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.tab-label {
  /* font-size: 14px; */
  font-weight: 500;
  white-space: nowrap;
}

.tab-item.active .tab-icon,
.tab-item.active .tab-label {
  color: #fff;
}

/* 右侧内容区样式 */
.supplier-content {
  flex: 1;
  padding: 15px;
}
.supplier-title {
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  /* margin-bottom: 20px; */
  padding: 10px 0;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  position: relative;
}
/* 
.supplier-title:after {
  content: "";
  display: block;
  width: 50px;
  height: 3px;
  background: #409EFF;
  margin: 10px auto 0;
  border-radius: 3px;
} */

.dark-theme {
  background: transparent;
}

.supplier-display {
  height: 96%;
  display: flex;
  flex-direction: column;
  border: 1px dashed rgb(198, 227, 235);
}

/* 图片容器基础样式 */
.supplier-images {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 0 20px;
  box-sizing: border-box;
}

.supplier-images.image-count-1 {
  padding: 0;
}
.supplier-images.image-count-1 .image-wrapper {
  width: 80%;
  height: 80%;
  max-width: 800px;
  max-height: 500px;
}

.supplier-images.image-count-2 {
  justify-content: space-around;
}
.supplier-images.image-count-2 .image-wrapper {
  width: 45%;
  height: 50%;
  min-height: 300px;
}

.supplier-images.image-count-3 {
  justify-content: space-around;
  flex-wrap: wrap;
}
.supplier-images.image-count-3 .image-wrapper {
  width: 30%;
  height: 45%;
  min-height: 250px;
}

.supplier-images.image-count-4 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 30px;
  padding: 0 20px;
  height: 90%;
  margin-top: 20px;
}
.supplier-images.image-count-4 .image-wrapper {
  width: 98%;
  height: 96%;
}
/* 基础容器设置 */

/* 图片容器通用样式 */
.image-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 5px;
  /* border-radius: 8px; */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: #f5f5f5;
}

.supplier-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.image-wrapper:hover .supplier-image {
  transform: scale(1.03);
}

/* 响应式调整 */
@media (max-width: 992px) {
  .supplier-images.image-count-1 .image-wrapper {
    width: 90%;
    height: 70%;
  }
  .supplier-images.image-count-2 .image-wrapper {
    height: 280px;
  }
}

@media (max-width: 768px) {
  .supplier-images {
    grid-template: unset;
    grid-auto-rows: minmax(200px, 1fr);
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .supplier-images.image-count-3 .image-wrapper:nth-child(3),
  .supplier-images.image-count-2 .image-wrapper {
    grid-column: unset;
    width: 100%;
    height: 200px;
  }
}

.supplier-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.image-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  text-align: center;
  font-size: 18px;
}

.el-carousel {
  height: 570px;
}

.el-carousel__container {
  height: 100%;
}

.el-carousel__arrow {
  background-color: rgba(64, 158, 255, 0.8);
  backdrop-filter: blur(5px);
}

.el-carousel__indicator >>> .el-carousel__button {
  background-color: rgba(255, 255, 255, 0.4);
}

.el-carousel__indicator.is-active >>> .el-carousel__button {
  background-color: #409eff;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .supplier-layout {
    flex-direction: column;
    min-height: auto;
  }

  .custom-tabs {
    width: 100%;
    flex-direction: row;
    overflow-x: auto;
    padding: 10px 5px;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .tab-item {
    flex: 0 0 auto;
    margin: 0 8px;
    padding: 10px 15px;
  }

  .supplier-content {
    padding: 10px;
  }

  .el-carousel {
    height: 500px;
  }
}

@media (max-width: 768px) {
  .supplier-images.image-count-1 .image-wrapper {
    width: 90%;
    height: 70%;
  }

  .supplier-images.image-count-2 {
    flex-direction: column;
    align-items: center;
  }
  .supplier-images.image-count-2 .image-wrapper {
    width: 90%;
    height: 45%;
  }

  .supplier-images.image-count-3 {
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(200px, 1fr);
  }

  .supplier-images.image-count-4 {
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(200px, 1fr);
  }

  .el-carousel {
    height: 700px;
  }
}
</style>
